function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0 0.186L3.146 0.186 3.146 3.333 0 3.333z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__c",
  d: "M0.222 0.162L15.222 0.162 15.222 15.196 0.222 15.196z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(.5)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5) translate(2.667 2.667) translate(0 15.505)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1A1919",
  d: "M3.146 1.759c0 .87-.704 1.574-1.573 1.574C.705 3.333 0 2.628 0 1.76 0 .89.705.186 1.573.186c.869 0 1.573.704 1.573 1.573",
  mask: "url(#prefix__b)",
  opacity: 0.64
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5) translate(2.667 2.667) translate(3.333 .172)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1A1919",
  d: "M9.902.634L8.05 2.51l-.703.707-4.753 4.795c-.17.17-.3.383-.377.612L.25 14.487c-.065.193-.015.407.13.552.103.102.24.157.38.157.057 0 .115-.01.172-.028l5.825-1.973c.232-.079.445-.212.617-.386l4.758-4.792 2.629-2.645c.301-.303.466-.706.461-1.135-.005-.428-.177-.828-.486-1.125L12.13.605c-.297-.286-.688-.443-1.1-.443-.427 0-.828.167-1.128.472zm-1.056 2.6l1.82-1.845c.098-.098.227-.152.365-.152.132 0 .257.05.353.143l2.607 2.508c.098.095.154.224.156.36 0 .139-.051.269-.149.366l-1.896 1.909-3.256-3.288zm-5.61 5.732c.026-.074.068-.142.122-.196l4.73-4.772.488.492-4.71 4.742-.856 2.565.587.584 2.547-.863 4.702-4.736.498.504-4.733 4.766c-.055.056-.124.099-.198.124l-4.8 1.625 1.624-4.835zm1.565 1.619c-.123-.114-.185-.26-.185-.436 0-.171.062-.318.185-.443l4.477-4.508.87.88-4.475 4.507c-.123.124-.27.187-.44.187-.17 0-.313-.063-.432-.187z",
  mask: "url(#prefix__d)",
  opacity: 0.64
}))));

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit.b2e1469b.svg";
export { ForwardRef as ReactComponent };